function getValue(condition, value, defaultValue) {
  return condition ? value : defaultValue;
}

export default getValue;
